import axios from 'axios';
import { IBrandCollection } from 'entities/Brand/Brand.models';

const basePath = 'good';

export const brandTransport = {
  get: (): Promise<IBrandCollection> => axios.get(`${basePath}/brands`),
};
